// checkbox, radio group, switch

const defaultProps = {
  color: 'inputElements'
};
export default {
  defaultProps
};
//# sourceMappingURL=MuiFormLabel.js.map